module.exports = {
      id: "menu-usage",
      viewBox: "0 0 18 11",
      url: __webpack_public_path__ + "img/icons.91580017.svg#menu-usage",
      toString: function () {
        return this.url;
      }
    }